export const version = '1.8.3';
//# sourceMappingURL=version.js.map